<template>
  <div class="echarts" id="threechartsunit"></div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  inject,
  watchEffect,
  nextTick,
  // watch // watch([()=>data.要监听的属性,...监听多个属性],(newValue,oldValue)=>{})
} from "vue";
//

import { ageType } from "@/api/dataAnalysis/populationAnalysis.js";
import * as echarts from "echarts";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      echartsList: [],
    });
    const refData = toRefs(data);
    const areaData = inject("areaData");
    const regionInfo = inject("region");
    watchEffect(() => {
      if (regionInfo.regionList) {
        nextTick(() => {
          threechartsunit();
        });
      }
    });
    const numberall = async () => {
      const param = {
        regionIds: regionInfo.regionList.toString(),
      };
      const res = await ageType(param);
      data.echartsList = res.data;
    };
    let mythreechartsunit;
    const threechartsunit = async () => {
      await numberall();
      mythreechartsunit = echarts.init(
        document.getElementById("threechartsunit")
      );
      const datas = data.echartsList;
      const option = {
        title: {
          // text: '数量',
          left: "1.7%",
          top: "1%",
          textStyle: {
            color: "#fff",
            //  type: 'dashed',
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          top: 20,
          left: 20,
          right: 5,
          bottom: 30,
          // containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: datas.map((e) => e.name),
            axisLine: {
              lineStyle: {
                color: "#3183bc",
                //  type: 'dashed',
              },
            },
            axisLabel: {
              show: true,
              color: "#fff",
              interval: 0,
              fontSize: 14,

              formatter: function (val) {
                var strs = val.split(""); // 字符串数组
                var str = "";
                for (var i = 0, s; (s = strs[i++]); ) {
                  // 遍历字符串数组
                  str += s;
                  if (!(i % 8)) str += "\n"; // 按需要求余
                }
                return str;
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            // name: "单位：人",
            nameTextStyle: {
              color: "#3183bc",
              fontSize: 16,
            },
            axisLabel: {
              formatter: "{value}",
              color: "#fff",
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                width: 1,
                color: "#3183bc",
              },
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#3A67A1", // "rgba(0,186,255,.6)"
              },
            },
          },
        ],
        series: [
          {
            type: "bar",
            data: datas.map((e) => e.value),
            barWidth: "28px",
            itemStyle: {
              normal: {
                borderColor: "#7acff4",
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(96, 143, 179, .3)", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(44, 126, 182, 1)", // 100% 处的颜色
                    },
                  ],
                  false
                ),
                // shadowColor:  "rgba(0,160,221,1)",
                // shadowBlur: 4
              },
            },
            label: {
              normal: {
                color: "#fff",
                show: true,
                formatter: "{c}",
                position: "top",
              },
            },
          },
        ],
      };
      mythreechartsunit.setOption(option);
    };
    onMounted(() => {
      window.addEventListener("resize", () => {
        mythreechartsunit.resize();
      });
    });

    return { ...refData };
  },
});
</script>
<style lang="scss" scoped>
#threechartsunit {
  width: 100%;
  height: 90%;
}
</style>
